export const skillTypes = [
    { value: '1', label: "Grammar & Vocabulary" },
    { value: '2', label: "Listening" },
    { value: '3', label: "Writing" },
    { value: '4', label: "Reading" },
    { value: '5', label: "Speaking" },
    { value: '6', label: "Reading and Writing" },
    { value: '7', label: "听力 (Nghe )" },
    { value: '8', label: "阅读 (Đọc)" },
    { value: '9', label: "书写 (Viết)" },
];
